export const DATA_API_BASE = 'https://dymtf33v6f.execute-api.eu-west-1.amazonaws.com';
export const ACTION_API_BASE = 'https://r94zvjxrui.execute-api.eu-west-1.amazonaws.com';

export const entriesUrl = (tableName: string) =>
  `${DATA_API_BASE}/entries?tableName=${encodeURIComponent(tableName)}`;

export const defaultActionUrl = (action: string) => `${ACTION_API_BASE}/default/${action}`;

export const validateUrl = `${DATA_API_BASE}/validate`;

// Common action URLs
export const addPlayerUrl = defaultActionUrl('addPlayer');
export const amendPlayerUrl = defaultActionUrl('amendPlayer');
export const deletePlayerUrl = defaultActionUrl('deletePlayer');
export const addFixtureUrl = defaultActionUrl('addFixture');
export const updateStatsUrl = defaultActionUrl('updateStats');
export const addTeamLogoUrl = defaultActionUrl('addTeamLogo');

// cache keys used throughout the app
export const CACHE_KEYS = {
  fixtures: 'fixtures_api_cache',
  results: 'results_api_cache',
  players: 'players_api_cache',
  stats: 'stats_api_cache',
  skaterStats: 'skater_stats_api_cache',
  goalieStats: 'goalie_stats_api_cache',
  fixturesTeamLogo: 'fixtures_api_cache_for_team_logo',
  fixturesGameSheetFixtures: 'fixtures_api_cache_for_game_sheet_fixtures',
  resultsGameSheetFixtures: 'results_api_cache_for_game_sheet_fixtures',
  fixturesGameSheetTeams: 'fixtures_api_cache_for_game_sheet_teams',
  resultsGameSheetTeams: 'results_api_cache_for_game_sheet_teams',
} as const;

